// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.104.1_esbuild@0.27.2_/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.104.1_esbuild@0.27.2_/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  color: none;
  background: none;
}

/*===============================Pasos=================*/
.step-wizard {
  background-color: #21d4fd;
  margin: 3% 0 3% 0;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.step-wizard-list {
  box-shadow: 0 15px 25px rgba(0, 0, 0, 0.1);
  color: #333;
  list-style-type: none;
  border-radius: 10px;
  display: flex;
  margin: auto;
  padding: 20px 10px;
  position: relative;
  z-index: 10;
  background: white;
}

.label {
  position: absolute;
  top: 60px;
  font-size: 10px;
  left: 10%;
}

.step-wizard-item {
  padding: 0 2px;
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  text-align: center;
  min-width: 70px;
  position: relative;
}

.step-wizard-item + .step-wizard-item:after {
  content: "";
  position: absolute;
  left: 0;
  top: 19px;
  background: #21d4fd;
  width: 100%;
  height: 2px;
  transform: translateX(-50%);
  z-index: -10;
}

.progress-count {
  height: 40px;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-weight: 600;
  margin: 0 auto;
  position: relative;
  z-index: 10;
  color: transparent;
}

.progress-count:after {
  content: "";
  height: 40px;
  width: 40px;
  background: #21d4fd;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  z-index: -10;
}

.progress-count:before {
  content: "";
  height: 10px;
  width: 20px;
  border-left: 3px solid #fff;
  border-bottom: 3px solid #fff;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -60%) rotate(-45deg);
  transform-origin: center center;
}

.current-item .progress-count:before,
.current-item ~ .step-wizard-item .progress-count:before {
  display: none;
}

.current-item ~ .step-wizard-item .progress-count:after {
  height: 10px;
  width: 10px;
}

.current-item .progress-count:after {
  background: #fff;
  border: 2px solid #21d4fd;
}

.current-item .progress-count {
  color: #21d4fd;
}

.section {
  padding: 25px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.container {
  background-color: #fff;
  padding: 20px;
  border-radius: 5px;
  margin-bottom: 20px;
  color: var(--ion-color-primary-darker-shade);
  font-size: 16px;
}

.title {
  margin-bottom: 8px;
}

:root {
  --small-font-size: 10px;
  --normal-font-size: 16px;
}

.header {
  border-top: 20px solid rgb(0, 153, 255);
}

.header-title {
  color: var(--ion-color-primary-darker-shade);
  font-size: 32px;
  border-bottom: 1px solid var(--ion-color-medium-shade);
  padding-bottom: 15px;
}

.header-subtitle {
  padding-top: 10px;
  color: var(--ion-color-medium-shade);
  font-size: var(--normal-font-size);
}

.description-p {
  font-size: var(--normal-font-size);
}

.checkbox {
  color: var(--ion-color-primary-darker-shade);
  font-size: var(--normal-font-size);
}

.checkbox-item {
  color: var(--ion-color-primary-darker-shade);
  font-size: var(--normal-font-size);
}

.checkbox-chechbox {
  --background: #fff;
  --checkmark-color: white;
}

.checkbox-label {
  margin-left: 10px;
}

.select-an-option {
  font-size: 12px;
  color: var(--ion-color-danger);
}

ion-checkbox {
  --size: 24px !important;
  --checkbox-background: #fff !important;
  --checkbox-background-checked: #6815ec !important;
  --border-color: #c4c4c4 !important;
  --border-color-checked: #6815ec !important;
  --border-width: 2px !important;
  --border-radius: 4px !important;
  --checkmark-color: #fff !important;
  --checkmark-width: 2px !important;
  width: 24px;
  height: 24px;
}

ion-checkbox::part(container) {
  background: #fff !important;
  border: 2px solid #c4c4c4 !important;
  border-radius: 4px !important;
  transition: background-color 0.15s ease, border-color 0.15s ease;
}

ion-checkbox.checkbox-checked::part(container) {
  background: #6815ec !important;
  border-color: #6815ec !important;
}

ion-checkbox::part(mark) {
  stroke: #fff !important;
  color: #fff !important;
  stroke-width: 2px !important;
}

ion-icon {
  font-size: 55px;
}

ion-radio {
  --color: #c4c4c4 !important;
  --color-checked: #6815ec !important;
  width: 24px;
  height: 24px;
  opacity: 1;
}

ion-radio::part(container) {
  width: 24px !important;
  height: 24px !important;
  border-radius: 50% !important;
  border: 2px solid #c4c4c4 !important;
  background: #fff !important;
  transition: border-color 0.15s ease;
}

ion-radio::part(mark) {
  width: 12px !important;
  height: 12px !important;
  border-radius: 50% !important;
  background: transparent !important;
  border: none !important;
  transform: none !important;
  transition: background-color 0.15s ease;
}

ion-radio.radio-checked::part(container) {
  border-color: #6815ec !important;
}

ion-radio.radio-checked::part(mark) {
  background: #6815ec !important;
}

.button-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.footer-button {
  align-self: center;
  width: 40%;
  height: 50px;
  border-radius: 10px;
  --background: var(--ion-color-success);
  --color: var(--ion-color-light);
}

@media screen and (min-width: 650px) {
  .container {
    margin: 0 10% 20px 10%;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/modals/survey/survey.component.scss"],"names":[],"mappings":"AAAA;EACE,SAAA;EACA,UAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;AACF;;AAEA,wDAAA;AAEA;EACE,yBAAA;EACA,iBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,0CAAA;EACA,WAAA;EACA,qBAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,iBAAA;AAAF;;AAEA;EACE,kBAAA;EACA,SAAA;EACA,eAAA;EACA,SAAA;AACF;;AAEA;EACE,cAAA;EACA,aAAA;EAGA,YAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;AACF;;AAEA;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,mBAAA;EACA,WAAA;EACA,WAAA;EACA,2BAAA;EACA,YAAA;AACF;;AAEA;EACE,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,kBAAA;EACA,YAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,WAAA;EACA,2BAAA;EACA,6BAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,+CAAA;EACA,+BAAA;AACF;;AAEA;;EAEE,aAAA;AACF;;AAEA;EACE,YAAA;EACA,WAAA;AACF;;AAEA;EACE,gBAAA;EACA,yBAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAKA;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AAFF;;AAIA;EACE,sBAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,4CAAA;EACA,eAAA;AADF;;AAIA;EACE,kBAAA;AADF;;AAKA;EACE,uBAAA;EACA,wBAAA;AAFF;;AAMA;EACE,uCAAA;AAHF;;AAKA;EACE,4CAAA;EACA,eAAA;EACA,sDAAA;EACA,oBAAA;AAFF;;AAIA;EACE,iBAAA;EACA,oCAAA;EACA,kCAAA;AADF;;AAIA;EACE,kCAAA;AADF;;AAGA;EACE,4CAAA;EACA,kCAAA;AAAF;;AAEA;EACE,4CAAA;EACA,kCAAA;AACF;;AACA;EACE,kBAAA;EACA,wBAAA;AAEF;;AAAA;EACE,iBAAA;AAGF;;AAAA;EACE,eAAA;EACA,8BAAA;AAGF;;AAOA;EACE,uBAAA;EACA,sCAAA;EACA,iDAAA;EACA,kCAAA;EACA,0CAAA;EACA,8BAAA;EACA,+BAAA;EACA,kCAAA;EACA,iCAAA;EACA,WAAA;EACA,YAAA;AAJF;;AAOA;EACE,2BAAA;EACA,oCAAA;EACA,6BAAA;EACA,gEAAA;AAJF;;AAOA;EACE,8BAAA;EACA,gCAAA;AAJF;;AAOA;EACE,uBAAA;EACA,sBAAA;EACA,4BAAA;AAJF;;AAOA;EACE,eAAA;AAJF;;AAUA;EACE,2BAAA;EACA,mCAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;AAPF;;AAUA;EACE,sBAAA;EACA,uBAAA;EACA,6BAAA;EACA,oCAAA;EACA,2BAAA;EACA,mCAAA;AAPF;;AAUA;EACE,sBAAA;EACA,uBAAA;EACA,6BAAA;EACA,kCAAA;EACA,uBAAA;EACA,0BAAA;EACA,uCAAA;AAPF;;AAUA;EACE,gCAAA;AAPF;;AAUA;EACE,8BAAA;AAPF;;AAUA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAPF;;AAUA;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,sCAAA;EACA,+BAAA;AAPF;;AAUA;EACE;IACE,sBAAA;EAPF;AACF","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  color: none;\n  background: none;\n}\n\n/*===============================Pasos=================*/\n\n.step-wizard {\n  background-color: #21d4fd;\n  margin: 3% 0 3% 0;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.step-wizard-list {\n  box-shadow: 0 15px 25px rgba(0, 0, 0, 0.1);\n  color: #333;\n  list-style-type: none;\n  border-radius: 10px;\n  display: flex;\n  margin: auto;\n  padding: 20px 10px;\n  position: relative;\n  z-index: 10;\n  background: white;\n}\n.label {\n  position: absolute;\n  top: 60px;\n  font-size: 10px;\n  left: 10%;\n}\n\n.step-wizard-item {\n  padding: 0 2px;\n  flex-basis: 0;\n  -webkit-box-flex: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n  max-width: 100%;\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n  min-width: 70px;\n  position: relative;\n}\n\n.step-wizard-item + .step-wizard-item:after {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 19px;\n  background: #21d4fd;\n  width: 100%;\n  height: 2px;\n  transform: translateX(-50%);\n  z-index: -10;\n}\n\n.progress-count {\n  height: 40px;\n  width: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  font-weight: 600;\n  margin: 0 auto;\n  position: relative;\n  z-index: 10;\n  color: transparent;\n}\n\n.progress-count:after {\n  content: '';\n  height: 40px;\n  width: 40px;\n  background: #21d4fd;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  border-radius: 50%;\n  z-index: -10;\n}\n\n.progress-count:before {\n  content: '';\n  height: 10px;\n  width: 20px;\n  border-left: 3px solid #fff;\n  border-bottom: 3px solid #fff;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -60%) rotate(-45deg);\n  transform-origin: center center;\n}\n\n.current-item .progress-count:before,\n.current-item ~ .step-wizard-item .progress-count:before {\n  display: none;\n}\n\n.current-item ~ .step-wizard-item .progress-count:after {\n  height: 10px;\n  width: 10px;\n}\n\n.current-item .progress-count:after {\n  background: #fff;\n  border: 2px solid #21d4fd;\n}\n\n.current-item .progress-count {\n  color: #21d4fd;\n}\n\n// /*===============================FORMULARIOS=================*/\n\n//REUSABLES\n.section {\n  padding: 25px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n.container {\n  background-color: #fff;\n  padding: 20px;\n  border-radius: 5px;\n  margin-bottom: 20px;\n  color: var(--ion-color-primary-darker-shade);\n  font-size: 16px;\n}\n\n.title {\n  margin-bottom: 8px;\n}\n\n//font-sizes\n:root {\n  --small-font-size: 10px;\n  --normal-font-size: 16px;\n}\n\n//Header\n.header {\n  border-top: 20px solid rgb(0, 153, 255);\n}\n.header-title {\n  color: var(--ion-color-primary-darker-shade);\n  font-size: 32px;\n  border-bottom: 1px solid var(--ion-color-medium-shade);\n  padding-bottom: 15px;\n}\n.header-subtitle {\n  padding-top: 10px;\n  color: var(--ion-color-medium-shade);\n  font-size: var(--normal-font-size);\n}\n\n.description-p {\n  font-size: var(--normal-font-size);\n}\n.checkbox {\n  color: var(--ion-color-primary-darker-shade);\n  font-size: var(--normal-font-size);\n}\n.checkbox-item {\n  color: var(--ion-color-primary-darker-shade);\n  font-size: var(--normal-font-size);\n}\n.checkbox-chechbox {\n  --background: #fff;\n  --checkmark-color: white;\n}\n.checkbox-label {\n  margin-left: 10px;\n}\n\n.select-an-option {\n  font-size: 12px;\n  color: var(--ion-color-danger);\n}\n\n// Shared sizing for both controls so they line up in a list\n$control-size: 24px;\n$control-border: 2px solid #c4c4c4;\n$control-accent: #6815ec;\n\n// Vanilla overrides — ignore any `color=...` attribute on the element\n// and force a consistent purple accent + visible white checkmark.\nion-checkbox {\n  --size: #{$control-size} !important;\n  --checkbox-background: #fff !important;\n  --checkbox-background-checked: #{$control-accent} !important;\n  --border-color: #c4c4c4 !important;\n  --border-color-checked: #{$control-accent} !important;\n  --border-width: 2px !important;\n  --border-radius: 4px !important;\n  --checkmark-color: #fff !important;\n  --checkmark-width: 2px !important;\n  width: #{$control-size};\n  height: #{$control-size};\n}\n\nion-checkbox::part(container) {\n  background: #fff !important;\n  border: 2px solid #c4c4c4 !important;\n  border-radius: 4px !important;\n  transition: background-color 0.15s ease, border-color 0.15s ease;\n}\n\nion-checkbox.checkbox-checked::part(container) {\n  background: #{$control-accent} !important;\n  border-color: #{$control-accent} !important;\n}\n\nion-checkbox::part(mark) {\n  stroke: #fff !important;\n  color: #fff !important;\n  stroke-width: 2px !important;\n}\n\nion-icon {\n  font-size: 55px;\n}\n\n// Radio: circle with a centered dot when selected.\n// Explicit pixel sizes on the shadow parts — Ionic's `md` defaults\n// (20px outer / 10px inner) make them look tiny next to the 24px checkbox.\nion-radio {\n  --color: #c4c4c4 !important;\n  --color-checked: #{$control-accent} !important;\n  width: #{$control-size};\n  height: #{$control-size};\n  opacity: 1;\n}\n\nion-radio::part(container) {\n  width: #{$control-size} !important;\n  height: #{$control-size} !important;\n  border-radius: 50% !important;\n  border: #{$control-border} !important;\n  background: #fff !important;\n  transition: border-color 0.15s ease;\n}\n\nion-radio::part(mark) {\n  width: 12px !important;\n  height: 12px !important;\n  border-radius: 50% !important;\n  background: transparent !important;\n  border: none !important;\n  transform: none !important;\n  transition: background-color 0.15s ease;\n}\n\nion-radio.radio-checked::part(container) {\n  border-color: #{$control-accent} !important;\n}\n\nion-radio.radio-checked::part(mark) {\n  background: #{$control-accent} !important;\n}\n\n.button-container {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.footer-button {\n  align-self: center;\n  width: 40%;\n  height: 50px;\n  border-radius: 10px;\n  --background: var(--ion-color-success);\n  --color: var(--ion-color-light);\n}\n\n@media screen and (min-width: 650px) {\n  .container {\n    margin: 0 10% 20px 10%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
